<template>
  <div class="filter-bar">
    <div class="upper-bar">
      <btn size="xs" @click="collapse = !collapse" type="primary">
        Filtres
        <span class="glyphicon glyphicon-menu-down" v-if="collapse" />
        <span class="glyphicon glyphicon-menu-up" v-else />
      </btn>
      <div v-if="statistics != null">
        <div class="statistics btn-xs" v-html="statistics">
        </div>
      </div>
      <div v-if="summary != null">
        <div class="summary btn-xs txt-dark-warning">
          <strong>{{ summary.substring(0, 500) }}</strong>
        </div>
      </div>
    </div>
    <div v-if="multiFilterData.length > 0">
      <collapse v-model="collapse">
        <div class="row filter-collapse">
          <div class="col-xs-12">
            <sui-multi-filter-input v-model="filter"
                                    :list="multiFilterData"
                                    :helps="multiFilterHelps"
                                    v-on="multiFilterEvents">
            </sui-multi-filter-input>
          </div>
        </div>
      </collapse>
    </div>
  </div>
</template>
<script>
import suiMultiFilterInput from '@/sui/components/multiFilterInput'

export default {
  name: 'filter-bar',

  props: {
    multiFilterData: {
      type: Array,
      required: true
    },

    multiFilterEvents: {
      type: Object,
      required: true
    },

    multiFilterHelps: {
      type: Array
    },

    selectionInfo: {
      type: Object
    }
  },

  data: function () {
    return {
      filter: '',
      allSheets: null,
      collapse: true
    }
  },

  computed: {
    summary: function () {
      if (this.selectionInfo == null || this.selectionInfo.filter == null ||
          this.selectionInfo.filter === '') {
        return null
      }

      if (this.selectionInfo.filter.length > 200) {
        return `${this.selectionInfo.filter.substring(0, 200)}...`
      }
      return this.selectionInfo.filter
    },

    statistics: function () {
      if (this.selectionInfo == null || this.selectionInfo.statistics == null) {
        return null
      }

      const { count, total } = this.selectionInfo.statistics

      return `<strong class='txt-dark-warning'>${count}</strong> / <strong class='txt-dark-warning'>${total} </strong>`
    }
  },

  components: {
    'sui-multi-filter-input': suiMultiFilterInput
  }
}
</script>
<style scoped lang="less">
@import '~variables';

.filter-bar {
  position: fixed;
  bottom: 0%;
  left: 0%;
  background-color: lighten(@base, 45%);
  width: 100%;
  padding: 0.5rem;
  z-index: 1000;
  border-top: 1px solid lighten(@base, 35%);
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;

  .multi-filter-input {
    margin-top: 0.5rem;
  }

  .upper-bar {
    display: flex;
    gap: 0.5rem;
    margin-left: 0.5rem;
    margin-top: -2rem;
    margin-bottom: 0rem;
  }

  .filter-collapse {
    min-height: 18rem;
  }

  .summary {
    background-color: white;
    border: 1px solid @btn-warning-border;
  }

  .statistics {
    background-color: white;
    border: 1px solid @btn-warning-border;
  }
}
</style>
